import React from "react";
import ClientsSelect from "../../../elements/clients/ClientsSelect";
import DefaultButton from "../../../styles/materialButtonStyle";

import {
  StyledDialogAction,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../../styles/styledDialog";

const ClientCommandDialog = ({
  t,
  setOpen,
  data,
  setData,
  handleSubmit,
  loading
}) => {

  const handleClose = () => {
    setData({});
    setOpen(false);
  };

  return (
    <>
      <StyledDialogWrapper>
        <StyledDialogHead>
          {t("command.modal.title")}
        </StyledDialogHead>
        <StyledDialogContent>
          <ClientsSelect
            checkedUser={data.user}
            setCheckedUser={(data) => setData((prev) => ({ ...prev, user: data }))}
          />
        </StyledDialogContent>
        <StyledDialogAction col="2">
          <DefaultButton
            onClick={handleClose}
            color="danger"
            disabled={loading}
          >
            {t("command.modal.cancel")}
          </DefaultButton>
          <DefaultButton
            color="success"
            onClick={handleSubmit}
            disabled={loading}
          >
            {t("command.modal.execute")}
          </DefaultButton>
        </StyledDialogAction>
      </StyledDialogWrapper>
    </>
  );
};

export default ClientCommandDialog;